/**
 * 数字名片模块路由
 * 路径前缀: /desktopCenter/digitalCard/
 */
import type { RouteRecordRaw } from "vue-router";

export const digitalCardRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/digitalCard/cardList",
		name: "CardList",
		meta: {
			title: "名片列表",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/corporate/card",
		},
		component: () => import("@main/views/Apps/DigitalCard/CardList/CardList.vue"),
	},
	{
		path: "/desktopCenter/digitalCard/cardBackground",
		name: "CardBackground",
		meta: {
			title: "名片背景",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/corporate/card_background",
		},
		component: () => import("@main/views/Apps/DigitalCard/CardBackground/CardBackground.vue"),
	},
];
